import React from 'react';
import Input from '../../Inputs/Input';
import Dropdown, { DropdownOption } from '../../Dropdown';
import { translate } from '../../../Services/translation';
import { defaultInvoiceQueryParams } from '../rma/MyPagesRmaDefaults';
import { ExtapiInvoiceSearchQueryParams } from '../../../Types/MyPages/InvoicesModel';
import LoadingSpinner from '../../LoadingSpinner';

export const filterFieldOptions: DropdownOption[] = [
  {
    label: translate('mypage.rma.itemnumber'),
    value: 'ItemNo',
  },
  {
    label: translate('mypage.rma.ean'),
    value: 'EanCode',
  },
  {
    label: translate('mypage.rma.invoicenumber'),
    value: 'InvoiceNo',
  },
  {
    label: translate('mypage.rma.ordernumber'),
    value: 'OrderNo',
  },
  {
    label: translate('mypage.rma.customerordernumber'),
    value: 'CustomerOrderNo',
  },
];

interface MyPagesInvoiceFilterFormProps {
  filter?: ExtapiInvoiceSearchQueryParams;
  onFilterChange: (filter: ExtapiInvoiceSearchQueryParams) => void;
  onSearch: () => void;
  isLoading: boolean;
}

const MyPagesInvoiceFilterForm = ({
  filter = defaultInvoiceQueryParams,
  onFilterChange,
  onSearch,
  isLoading,
}: MyPagesInvoiceFilterFormProps) => {
  return (
    <>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Input
          type="date"
          label={translate('mypage.invoices.date.from')}
          wrapperClassName="[&_.input]:text-lg"
          value={filter?.startDate ?? ''}
          disabled={isLoading}
          onChange={(e) =>
            onFilterChange({
              ...(filter ?? defaultInvoiceQueryParams),
              startDate: e.target.value,
            })
          }
          required
        />
        <Input
          type="date"
          label={translate('mypage.invoices.date.to')}
          wrapperClassName="[&_.input]:text-lg"
          value={filter?.endDate ?? ''}
          disabled={isLoading}
          onChange={(e) =>
            onFilterChange({
              ...(filter ?? defaultInvoiceQueryParams),
              endDate: e.target.value,
            })
          }
          required
        />
      </div>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <Dropdown
          className="lg:self-end [&>div]:bg-white"
          selectClassName="lg:h-[40px]"
          selectedValue={
            filter?.filterField ?? defaultInvoiceQueryParams.filterField
          }
          options={filterFieldOptions}
          onChange={(option) =>
            onFilterChange({
              ...(filter ?? defaultInvoiceQueryParams),
              filterField: option.value,
            })
          }
          label="Filter"
          size="medium"
        />
        <div className="grid grid-cols-3 gap-4">
          <Input
            inputSize="medium"
            label={
              filterFieldOptions.find(
                (x) => x.value == filter?.filterField
              )?.label
            }
            onKeyDown={(e) => e.key == 'Enter' && onFilterChange(filter)}
            wrapperClassName="lg:self-end [&_.input]:text-lg col-span-2"
            type="text"
            value={
              filter?.filterFieldSearchValue ??
              defaultInvoiceQueryParams.filterFieldSearchValue
            }
            disabled={isLoading || !filter?.filterField}
            onChange={(e) =>
              onFilterChange({
                ...(filter ?? defaultInvoiceQueryParams),
                filterFieldSearchValue: e.target.value,
              })
            }
            placeholder={
              filterFieldOptions.find(
                (x) => x.value == filter?.filterField
              )?.label
            }
          />
          <button
            className="btn btn--primary h-[40px] w-full self-end"
            disabled={isLoading}
            onClick={() => onSearch()}
          >
            {!isLoading && translate('form.invoices.search')}
            {isLoading && <LoadingSpinner className="h-6 w-6" />}
          </button>
        </div>
      </div>
    </>
  );
};

export default MyPagesInvoiceFilterForm;
